module.exports = "/_next/static/images/d187bc6c42cba56282f8b6c93fad42a3-roxinho-scene-card-with-phone-md@2x.jpg";